var map = {
	"./agpay/copy-icon.png": "cf36",
	"./aipay/copy-icon.png": "41f3",
	"./anpay/copy-icon.png": "ac44",
	"./qpay/copy-icon.png": "1c9c",
	"./qtpay/copy-icon.png": "f550"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "05ef";